import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
} from "antd";
import React, { useEffect } from "react";
import IntlMessage from "../../components/IntlMessage";
import { orderStatus } from "./order_status.type";
import { paymentStatus } from "./payment.type";
import { useIntl } from "react-intl";
import busOrdersApi from "../../api/bus_orders";

const { Option } = Select;

const BookingStatusForm = (props) => {
  const {
    isModalBookingStatus,
    setIsModalBookingStatus,
    onCloseModalBookingStatus,
    currentData,
    onRefresh,
  } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  let initialValues = {
    ...currentData,
    pay_status: currentData?.pay_status ?? null,
    order_status: currentData?.order_status ?? "",
  };

  const isMobile = window.innerWidth < 576;
  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        Promise.all([
          busOrdersApi.updatePaymentStatus(currentData?.id, {
            pay_status: values.pay_status,
          }),
          busOrdersApi.updateOrderStatus(currentData?.id, {
            order_status: values.order_status,
          }),
        ])
          .then((res) => {
            message.success("Updated successfully");
            setIsModalBookingStatus(false);
            onRefresh();
          })
          .catch((error) => {
            // setIsModalBookingStatus(false);
            throw new Error("Update failed");
          });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const onChangePayStatus = (e) => {};

  const onChangeOrderStatus = (e) => {};

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Modal
      title={<IntlMessage id="global.update_status" />}
      open={isModalBookingStatus}
      destroyOnClose={true}
      onCancel={onCloseModalBookingStatus}
      width={isMobile ? "100%" : "40%"}
      onOk={onCloseModalBookingStatus}
      footer={[
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          // loading={loading}
          onClick={handleOk}
        >
          {<IntlMessage id="global.ok" />}
        </Button>,
      ]}
    >
      <Form
        labelCol={{
          span: 12,
        }}
        wrapperCol={{
          span: 12,
        }}
        initialValues={initialValues}
        labelAlign="left"
        form={form}
        name="control-hooks"
        style={{ maxWidth: 1000 }}
      >
        <>
          <Form.Item
            label={<IntlMessage id="global.order_status" />}
            name="order_status"
            style={{ marginTop: 20, width: 300 }}
          >
            <Select
              showSearch
              onChange={onChangeOrderStatus}
              filterOption={false}
              placeholder={intl.formatMessage({
                id: "orders.order_status",
              })}
            >
              {orderStatus.map((item, index) => {
                return (
                  <Option value={item.value} key={index}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.pay_status" />}
            name="pay_status"
            style={{ marginTop: 20, width: 300 }}
          >
            <Select
              showSearch
              onChange={onChangePayStatus}
              filterOption={false}
              placeholder={intl.formatMessage({
                id: "global.payment_status",
              })}
            >
              {paymentStatus.map((item, index) => {
                return (
                  <Option value={item.value} key={index}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </>
      </Form>
    </Modal>
  );
};

export default BookingStatusForm;
